<template>
    <a-range-picker
         v-model="date"
        :format="'YYYY-MM-DD'"
        :disabledDate="disabledDate"
        :disabledTime="disabledRangeTime"
        @change="change"
    />
</template>

<script>
    import moment from "moment"
    export default {
        name: "dateRange",
        data(){
            return{
                date: [moment().subtract(7,'days'), moment()]
            }
        },
        methods:{
            moment,
            range(start, end) {
                const result = [];
                for (let i = start; i < end; i++) {
                    result.push(i);
                }
                return result;
            },

            disabledDate(current) {
                return current && current > moment().endOf('day');
            },

            disabledRangeTime(_, type) {
                if (type === 'start') {
                    return {
                        disabledHours: () => this.range(0, 60).splice(4, 20),
                        disabledMinutes: () => this.range(30, 60),
                        disabledSeconds: () => [55, 56],
                    };
                }
                return {
                    disabledHours: () => this.range(0, 60).splice(20, 4),
                    disabledMinutes: () => this.range(0, 31),
                    disabledSeconds: () => [55, 56],
                };
            },
            change(){
                let start = this.date[0].format('YYYY-MM-DD') + ' 00:00:00';
                let end = this.date[1].format('YYYY-MM-DD') + ' 23:59:59';
                start = moment(start).valueOf();
                end = moment(end).valueOf();
                //console.log(start, end)
                this.$emit('change', start, end);
            }
        }
    }
</script>

<style scoped>

</style>